// extracted by mini-css-extract-plugin
export var icon = "_f-1";
export var subtext = "_f-0";